/** @file Settings store: UI language, shortcut overrides and dock layout (SettingsSlice, from settings.ui.*). */
import { createStore } from 'zustand/vanilla';
import type { SettingsSlice } from './types';

/** English, no overrides, default layout until GET /settings/ui answers. */
export const settingsStore = createStore<SettingsSlice>()(() => ({ lang: 'en', shortcuts: [], layout: null }));
